// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".animate__animated.animate__slideInUp{--animate-duration:500ms}", "",{"version":3,"sources":["webpack://./resources/js/components/sheet/styles.css"],"names":[],"mappings":"AAAA,sCACI,wBACJ","sourcesContent":[".animate__animated.animate__slideInUp {\n    --animate-duration: 500ms;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
